import * as Sentry from "@sentry/react";
import packageJson from '../../package.json';

export function notifySentryError(err, { user, urlpass, params, location }) {
  // Ignorar errores de red del lado del cliente (desconexión, CORS, adblockers, timeouts)
  if (err?.message === 'Network Error' || (err?.isAxiosError && !err?.response)) {
    console.warn('Sentry ignore: Client network error', err);
    return; // No lo enviamos a Sentry
  }

  // Configurar usuario (equivalente a event.addMetadata('user', {...}))
  Sentry.setUser({
    id: user?.user?.user?.id_alumno,
    username: user?.user?.user?.Nombre,
    email: user?.user?.user?.email,
    matricula_academica: user?.user?.user?.No_de_matriculaacademica,
    matricula: user?.user?.user?.No_de_matricula,
    instituto: user?.user?.user?.INSTITUTO
  });

  // Metadata adicional (equivalente a event.addMetadata)
  Sentry.setContext('otherDetails', {
    url: urlpass,
    params
  });

  if (location) {
    Sentry.setContext('location', location);
  }
  Sentry.setContext('appDetails', {
    version: packageJson.version
  });

  // Capturar la excepción
  Sentry.captureException(err);
}